'use client';

interface ScoreDisplayProps {
  score: number;
}

/**
 * Score display component
 * Shows the game score at the top right of the screen
 */
export function ScoreDisplay({ score }: ScoreDisplayProps) {
  return (
    <div className="absolute right-6 top-6 z-7">
      {/* Score text */}
      <span className="mr-1 text-[36px] font-extrabold leading-normal tracking-normal text-g-90">
        {score}
      </span>

      {/* Score label */}
      <span className="text-center typo-body-5 text-g-90">
        층
      </span>
    </div>
  );
}
